var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYahoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 278,
    viewBox: "0 0 1001 278",
    width: 1001,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.941406 0h1000v277.324h-1000z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.941406 67.511h59.493394l34.6423 88.629 35.0919-88.629h57.927l-87.225 209.813h-58.2937l23.8764-55.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.44 63.9827c-44.7 0-72.959 40.0893-72.959 80.0113 0 44.925 30.982 80.542 72.111 80.542 30.68 0 42.248-18.693 42.248-18.693v14.561h51.89v-152.8922h-51.89v13.8993s-12.906-17.4284-41.4-17.4284zm11.037 49.1333c20.625 0 31.268 16.32 31.268 31.046 0 15.857-11.402 31.418-31.268 31.418-16.464 0-31.343-13.455-31.343-30.743 0-17.533 11.968-31.721 31.343-31.721z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.601 220.403v-220.403h54.273v81.9405s12.891-17.9389 39.89-17.9389c33.026 0 52.375 24.6066 52.375 59.7684v96.633h-53.876v-83.396c0-11.899-5.669-23.394-18.508-23.394-13.07 0-19.881 11.669-19.881 23.394v83.396z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m598.673 64.0007c-51.19 0-81.671 38.9253-81.671 80.6293 0 47.46 36.906 79.906 81.865 79.906 43.577 0 81.708-30.973 81.708-79.11 0-52.6696-39.925-81.4253-81.902-81.4253zm.489 49.5653c18.082 0 30.594 15.061 30.594 31.121 0 13.698-11.659 30.594-30.594 30.594-17.35 0-30.371-13.918-30.371-30.744 0-16.209 10.825-30.971 30.371-30.971z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m770.992 64.0007c-51.19 0-81.672 38.9253-81.672 80.6293 0 47.46 36.906 79.906 81.866 79.906 43.576 0 81.707-30.973 81.707-79.11 0-52.6696-39.924-81.4253-81.901-81.4253zm.488 49.5653c18.083 0 30.594 15.061 30.594 31.121 0 13.698-11.658 30.594-30.594 30.594-17.35 0-30.371-13.918-30.371-30.744 0-16.209 10.826-30.971 30.371-30.971z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m895.719 223.649c19.904 0 36.04-16.135 36.04-36.039s-16.136-36.04-36.04-36.04-36.039 16.136-36.039 36.04 16.135 36.039 36.039 36.039z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m943.601 138.331h-64.88l57.582-138.331h64.637z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahoo);
export default __webpack_public_path__ + "static/media/yahoo.50f28e77098caaf4d7f2085153d308af.svg";
export { ForwardRef as ReactComponent };